<h1 mat-dialog-title>خوش آمدید</h1>
<div mat-dialog-content>آیا میخواهید نحوه کار با سایت را ببینید؟</div>
<div class="row mx-1 mt-3">
  <button class="col-6 decline-btn" mat-dialog-close>خیر</button>
  <button class="col-6 accept-btn" (click)="askToStartTour()">بله</button>
</div>
